import { investorFeatureCodesApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const INVESTOR_FEATURE_CODES_ACTION_TYPE = createNamedActions('investorFeatureCodes', {
  GET_CODES: 'GET_CODES',
  CREATE_CODE: 'CREATE_CODE',
  EDIT_CODE: 'EDIT_CODE',
  DELETE_CODE: 'DELETE_CODE',
});

const investorFeatureCodeSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getInvestorFeatureCodesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await investorFeatureCodesApi.getCodes(params);

  return dispatch({
    type: INVESTOR_FEATURE_CODES_ACTION_TYPE.GET_CODES,
    payload: normalize(data, [investorFeatureCodeSchema]).entities.data,
  });
});

export const createInvestorFeatureCodeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await investorFeatureCodesApi.createCode(params);

  return dispatch({
    type: INVESTOR_FEATURE_CODES_ACTION_TYPE.CREATE_CODE,
    payload: data,
  });
});

export const editInvestorFeatureCodeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await investorFeatureCodesApi.editCode(params);

  return dispatch({
    type: INVESTOR_FEATURE_CODES_ACTION_TYPE.EDIT_CODE,
    payload: data,
  });
});

export const deleteInvestorFeatureCodeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await investorFeatureCodesApi.deleteCode(params);

  return dispatch({
    type: INVESTOR_FEATURE_CODES_ACTION_TYPE.DELETE_CODE,
    payload: data,
    meta: params,
  });
});
